import { PageTable, Header } from "/src/layouts/page";
import Table from "/src/components/table";
import "/src/components/UI/Button/IconButton/IconButton.css";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";
import brainService from "../../services/BrainService";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import BrainsModal from "../modal/BrainModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import getCutToken from "/src/utils/getCutToken";
import chatService from "../../services/ChatService";
import { formatDate } from "/src/utils/formatDate";
import storage from "/src/utils/storage";
import Field from "/src/components/UI/Field/Field";
import "../../css/WarningRagApiKey.css";

function BrainsTable() {
    const navigate = useNavigate();
    const { getBrains, deleteBrain } = brainService;
    const company = storage("session").get("company");
    const [refreshKey, setRefreshKey] = useState(0);
    const [apiError, setApiError] = useState(null);
    const toast = useToastDispatchContext();

    const fetchBrains = async (params) => {
        try {
            const [response, error] = await getBrains(params);

            if (error) {
                if (error.status === 401) {
                    setApiError("Invalid API key. Please contact the Talkr administrator.");
                } else {
                    setApiError(`Error fetching data: ${error.message}`);
                }
                return [null, error];
            }

            setApiError(null);
            return [response.brains.filter((brain) => brain.rights === "Owner"), null];
        } catch (error) {
            setApiError("An unexpected error occurred while fetching data.");
            return [null, error];
        }
    };

    const cells = [
        {
            column: "ID",
            name: "id",
            show: (value) => (
                <span
                    style={{ color: "var(--main)", cursor: "pointer" }}
                    onClick={(e) =>
                        navigator.clipboard.writeText(value).then((_) => {
                            toast.success("Copy ID to clipboard", "You can paste this token where you need !", 5000);
                        })
                    }>
                    {" "}
                    {getCutToken(value)}
                </span>
            ),
        },
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value) => value,
        },
        {
            column: "DESCRIPTION",
            name: "description",
            sort: true,
            show: (value) => value,
        },
        {
            column: "MODEL",
            name: "brain_model",
            sort: true,
            show: (value) => value,
        },
        {
            column: "MAX TOKENS",
            name: "max_tokens",
            show: (value) => value,
        },
        {
            column: "LAST UPDATE",
            name: "last_update",
            sort: true,
            show: (value) => formatDate(value),
        },
    ];

    const showAddModal = ({ addRow }) =>
        NiceModal.show(BrainsModal, {
            title: "Add Brain",
        }).then((brain) => addRow(brain));

    const showEditModal = ({ updateRow, row }) =>
        NiceModal.show(BrainsModal, {
            title: "Modify your Brain",
            data: { ...row },
        }).then((brain) => {
            setRefreshKey((oldKey) => oldKey + 1);
        });

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, name } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete Brain " + name,
            body: "You really want to delete brain " + name + " ?",
            api: {
                request: deleteBrain,
                param: [row.id],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
            confirm: {
                name: row.name,
                fieldName: "the brain",
            },
        }).then(() => deleteRow(id));
    };

    const brainSettings = ({ row }) => {
        const { id } = row;
        navigate(urlWithRoutingCompany(`/ai/llm-rag/${id}`));
    };

    const talkToBrain = async ({ row }) => {
        const { id } = row;

        try {
            const response = await chatService.createChat();
            if (response[0].chat_id) {
                navigate(urlWithRoutingCompany(`/ai/llm-rag/chat/${response[0].chat_id}?brainId=${id}`));
            } else {
                console.error("Chat ID not found in response:", response);
            }
        } catch (error) {
            console.error("Failed to create chat:", error);
        }
    };

    const actions = [
        { className: "fas fa-cog action-button edit_action", style: {}, onClick: showEditModal },
        { className: "fas fa-robot action-button edit_action", style: {}, onClick: talkToBrain },
        { className: "fas fa-download action-button edit_action", style: {}, onClick: brainSettings },
        { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete },
    ].filter((action) => action);

    const buttons = [{ icon: "fas fa-plus", onClick: showAddModal }];

    const filters = [{ type: "input", placeholder: "brains", name: "name" }];

    if (!company?.api_key_rag || apiError) {
        return (
            <PageTable>
                <Header title="List of Brains" />
                <div className="warning_container">
                    <Field listClassName="warning">
                        {apiError ||
                            "API key for Talkr RAG usage is not configured. Please contact the Talkr administrator."}
                    </Field>
                </div>
            </PageTable>
        );
    }

    return (
        <PageTable>
            <Header title="List of Brains"></Header>
            <Table
                key={refreshKey}
                name="Brains List"
                buttons={buttons}
                actions={actions}
                cells={cells}
                api={fetchBrains}
                withPagination={false}
                filters={filters}
                defaultSort={{ column: "last_update", val: false }}></Table>
        </PageTable>
    );
}

export default BrainsTable;
